import { InputNumber } from 'component/Input/InputNumber'
import { useLatestCallback } from 'hook/useLatestCallback'
import { i18n } from 'i18n'
import { observer } from 'mobx-react-lite'
import { useDemo } from 'page/catalog/store/CatalogContext'
import { UNLIMITED } from 'page/catalog/store/OptionsStore'
import { formatNumber } from 'util/number'
import { emdash } from 'util/typo'

export const MaxPriceInput = observer(() => {
  const { form, options } = useDemo()
  const { min_price, max_price } = form
  const { tsum_min_price, tsum_max_price } = options
  const min = tsum_min_price
  const max = tsum_max_price
  const count = max === UNLIMITED ? emdash : formatNumber(max)
  const placeholder = i18n('PriceTo', { count })

  const onChange = useLatestCallback((value: number | undefined) => {
    if (!value) {
      form.max_price = null
      return
    }

    value = Math.max(min, Math.min(max, value))
    form.max_price = value
    if (min_price && min_price >= value) form.min_price = value
  })

  return <InputNumber upper value={max_price} placeholder={placeholder} onChange={onChange} />
})
